module.exports = __webpack_public_path__ + "static/media/car-bluetooth.d7700295.svg";